<template>
  <div>
    <Divider orientation="left"><b>百度统计</b></Divider>
    <BaiDuSiteList ref="BaiDuSiteList"></BaiDuSiteList>

    <Divider orientation="left"><b>系统统计</b></Divider>
    <Form :model="dateFilter" style="margin: 20px 0 0 0;" ref="graphScreenFilter" label-position="left" inline>
      <FormItem>
        <radio-group v-model="dateFilter.date" type="button" @on-change="lastTimeChange">
          <radio label="today">今天</radio>
          <radio label="yesterday">昨天</radio>
          <radio label="seven">最近7天</radio>
          <radio label="thirty">最近30天</radio>
        </radio-group>
      </FormItem>
      <FormItem>
        <DatePicker
          :value="customDate"
          type="daterange"
          style="min-width: 250px;"
          @on-change="customTimeChange"
          @on-clear="customTimeClear"
          placeholder="自定义时间"
          class="mob-w-100"></DatePicker>
      </FormItem>
    </Form>
    <BaiYiBrowserSite ref="BaiYiBrowserSite" :start_date="dateFilter.start" :end_date="dateFilter.end"></BaiYiBrowserSite>
    <BaiYiSaturnSite ref="BaiYiSaturnSite" :start_date="dateFilter.start" :end_date="dateFilter.end"></BaiYiSaturnSite>
    <PolarisBaseSite ref="PolarisBaseSite" :start_date="dateFilter.start" :end_date="dateFilter.end"></PolarisBaseSite>
  </div>
</template>

<script>
import BaiDuSiteList from './site/list'
import BaiYiBrowserSite from './baiyi_broswer/baiyi_browser'
import BaiYiSaturnSite from './baiyi_saturn/baiyi_saturn'
import PolarisBaseSite from './polaris_base/polaris_base'

export default {
  name: 'baidu_tongji',
  components: {
    BaiDuSiteList,
    BaiYiBrowserSite,
    BaiYiSaturnSite,
    PolarisBaseSite
  },
  data () {
    return {
      dateFilter: {
        date: 'today',
        start: '',
        end: ''
      },
      customDate: ['', '']
    }
  },
  methods: {
    // 刷新
    refresh () {
      this.$refs.BaiYiBrowserSite.getTableData()
      this.$refs.BaiYiSaturnSite.getTableData()
      this.$refs.PolarisBaseSite.getTableData()
    },
    // 计算过去的日期
    timeC (day) {
      let date = new Date()
      let sD = new Date(date.getTime() - day * 24 * 60 * 60 * 1000)
      let sYear = sD.getFullYear()
      let sMonth = (sD.getMonth() + 1 < 10 ? '0' + (sD.getMonth() + 1) : sD.getMonth() + 1)
      let sDay = sD.getDate()
      return sYear + sMonth + sDay
    },
    // 选中日期触发
    lastTimeChange (label) {
      this.customDate = ['', '']
      this.dateFilter.start = ''
      this.dateFilter.end = ''

      let date = new Date()
      let year = date.getFullYear()
      let month = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
      let day = date.getDate()
      let nowDate = year + month + day
      switch (label) {
        case 'today':
          this.dateFilter.start = nowDate
          this.dateFilter.end = nowDate
          break
        case 'yesterday':
          let yesterdayStr = this.timeC(1)
          this.dateFilter.start = yesterdayStr
          this.dateFilter.end = yesterdayStr
          break
        case 'seven':
          this.dateFilter.start = this.timeC(7)
          this.dateFilter.end = nowDate
          break
        case 'thirty':
          this.dateFilter.start = this.timeC(30)
          this.dateFilter.end = nowDate
          break
      }
      this.$nextTick(() => {
        this.refresh()
      })
    },
    // 自定义时间触发
    customTimeChange (timeRange) {
      if (timeRange[0] && timeRange[1]) {
        this.dateFilter.date = ''
        this.dateFilter.start = timeRange[0].replace(/-/g, '')
        this.dateFilter.end = timeRange[1].replace(/-/g, '')
        this.$nextTick(() => {
          this.refresh()
        })
      } else {
        this.customTimeClear()
      }
    },
    // 自定义时间清除触发
    customTimeClear () {
      this.dateFilter.date = 'today'
      this.lastTimeChange('today')
    }
  }
}
</script>

<style scoped>

</style>
